import React, { Component } from 'react';
import PageTemplate from '../components/PageTemplate/PageTemplate';
import BasicText from '../components/BasicText/BasicText';
import ActionButton from '../components/ActionButton/ActionButton';
import DeviceQueryContainer from './DeviceQueryContainer';
import { ThermostatsActions } from '../../../store/actionCreators';
import { disconnectServiceProvider } from '../../../lib/functions';
import Store from '../../../store';

class DeviceViewContainer extends Component {
  handleSignOut = isEcobee => {
    const thermostatsState = Store.getState() && Store.getState().thermostats;
    if (thermostatsState != null && thermostatsState.awairQueryParams != null) {
      const deviceUuid = thermostatsState.awairQueryParams.deviceUuid;
      disconnectServiceProvider(deviceUuid, isEcobee);
    } else {
      alert("Device doesn't exist\nPlease try again later.");
    }
  };

  render() {
    const { contents, isEcobee } = this.props;
    ThermostatsActions.convertToInitialValue(false);
    return (
      <PageTemplate>
        <BasicText text={contents.choiceText} />
        <DeviceQueryContainer isEcobee={isEcobee} />
        <ActionButton negative={true} text={contents.logoutBtnText} onClick={() => this.handleSignOut(isEcobee)} />
      </PageTemplate>
    );
  }
}

export default DeviceViewContainer;



// WEBPACK FOOTER //
// ./src/app/thermostats/containers/DeviceViewContainer.js